"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendSignupPromptViewEvent = exports.sendLoginPromptViewEvent = void 0;
var __1 = require("../..");
var SIGNUP_PROMPT_VIEW_EVENT_NAME = "signup_prompt_view_v0";
var LOGIN_PROMPT_VIEW_EVENT_NAME = "login_prompt_view_v0";
/**
 * Sends an event that a login prompt was viewed
 * Event name: "login_prompt_view_v0"
 * @param eventDetails details of the event
 */
var sendLoginPromptViewEvent = function (eventDetails) {
    (0, __1.sendEvent)(null, null, null, LOGIN_PROMPT_VIEW_EVENT_NAME, eventDetails);
};
exports.sendLoginPromptViewEvent = sendLoginPromptViewEvent;
/**
 * Sends an event that a signup prompt was viewed
 * Event name: "signup_prompt_view_v0"
 * @param eventDetails details of the event
 */
var sendSignupPromptViewEvent = function (eventDetails) {
    (0, __1.sendEvent)(null, null, null, SIGNUP_PROMPT_VIEW_EVENT_NAME, eventDetails);
};
exports.sendSignupPromptViewEvent = sendSignupPromptViewEvent;
